import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { BackButton, EditButton } from "../../../../Components/Utils/Buttons";
import { NormalHeading } from "../../../../Components/Utils/Heading";
import NuDate from "../../../../Components/Utils/NuDate";
import CommonComments from "../../../../Components/Utils/commonComments";
import NuAmount from "../../../../Components/Utils/NuAmount";
import { Button, message, notification, Popover, Progress, Select } from "antd";
import ToggleUp from "../../../../Components/Icons/ToggleUp";
import ToggleDown from "../../../../Components/Icons/ToggleDown";

import { useFormik } from "formik";
import { handleKeyDown } from "../../../../Components/Utils/OtherFunction";
import { MainForm, MainFormInput } from "../../../../Components/Utils/MainForm";
import ViewFiles from "./viewFiles";
import imge from "../../../../assets/images/google.png";
import axiosInstance from "../../../../Services/axiosCommon";
import FilesView from "../../../../Components/Utils/FilesView";
import DownArrow from "../../../../Components/Icons/DownArrow";
import Doc from "../../../../Components/Icons/Doc";
import Xls from "../../../../Components/Icons/Xls";
import Txt from "../../../../Components/Icons/Txt";
import Pdf from "../../../../Components/Icons/Pdf";
import Video from "../../../../Components/Icons/Video";
import CustomAttachmentUpload from "../../../../Components/Utils/CustomFileUpload";
import { NuInput } from "../../../../Components/Utils/Input";
import axios from "axios";
import * as yup from "yup";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import EditSupportComments from "./EditSupportComments";
import moment from "moment";
import DecryptData from "../../../../Components/Utils/Decrypt";
import NuAvatarGroupWithOutLink from "../../../../Layouts/NuAvatarGroupWithoutLink";
import { GetAccess } from "../../../../Components/Utils/roles";
import { CalendarDays, User2 } from "lucide-react";

function ViewSupportTicket(onClose) {
  const { id, supportTickViewId } = useParams();
  const [assignee, setAssignee] = useState([]);
  const [copyTo, setCopyTo] = useState([]);
  const [teamId, setTeamId] = useState(0);
  const [taskPriority, setTaskPriority] = useState("");
  const [taskStatusDefualt, setTaskStatusDefualt] = useState("");
  const [taskProgressDefualt, setTaskProgressDefualt] = useState(0);
  const [allMembers, setAllMembers] = useState([]);
  const [members, setMembers] = useState([]);
  const [openAssignee, setOpenAssignee] = useState(false);

  const [open, setOpen] = useState(false);

  const [createNewComment, setCreateNewComment] = useState({
    mainId: supportTickViewId,

    comments: "",
    files: "",
  });
  const [createNew, setCreateNew] = useState({
    projectId: "",
    titleId: "",
    taskName: "",
    assignedTo: [],
    copyTo: [],
    priority: "",
    severity: "",
    taskStatus: "",
    // comment: "",
    startDate: "",
    endDate: "",
    reminderDate: "",
    reminderTime: "",
    attachment: "",
    reAssignedTo: [],
    taskTeam: "",
    noOFWeeks: "",
    noOFDays: "",
  });
  const [api, contextHolder] = notification.useNotification();

  const location = useLocation();
  const tdata = location.state.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  const [data, setData] = useState(tdata ? tdata : null);
  console.log(data, "jhvc");
  function getView() {
    axiosInstance
      .get(`/tickets/assigned-ticket-details/${supportTickViewId}`)
      .then((res) => {
        setData(res.data?.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  useEffect(() => {
    // if (!tdata) {
      getView();
    // }
  }, [supportTickViewId]);
  const userAccess = JSON.parse(localStorage.getItem("userAccess"));
  let TicketEditAccess = userAccess
    ? userAccess.some(
        (permission) => permission.permissionName == "Ticket_edit"
      )
    : false;

  const [selectedFile, setSelectedFile] = useState(null);
  const [image, setImage] = useState([]);

  const [comment, setComment] = useState([]);

  const handleChangeImg = (e) => {
    const maxFileSize = 200000000; // 200 MB
    let fileArr = [];
    let previewArr = [];

    if (e.target.files.length > 0) {
      const files = Array.from(e.target.files);
      files.forEach((item) => {
        if (item.size < maxFileSize) {
          fileArr.push(item);
          previewArr.push(URL.createObjectURL(item));
        } else {
          api.warning({
            message: `File Size too big`,
            description: `${item.name} is Removed and not Uploaded`,
            placement: "bottomRight",
          });
        }
      });
      setSelectedFile(fileArr);
      setImage(previewArr);
    }
  };

  async function getComments() {
    await axiosInstance
      .get(`/ticket-comments/by-ticket/${supportTickViewId}`)
      .then((res) => {
        setComment(res?.data?.data || []);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function handleChangeAssignee(e) {
    console.log("xyz", e);
    setAssignee(e);
  }
  // copy to
  function handleChangeCopyTo(e) {
    setCopyTo(e);
  }

  // chnage open Copy
  const handleOpenCopyChange = (newOpen) => {
    setOpen(newOpen);
  };

  // change open assignee
  const handleOpenAssigneeChange = (newOpen) => {
    setOpenAssignee(newOpen);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNewComment,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      comments: yup.string().required("Enter the Comment "),
    }),
    onSubmit: async (value, { resetForm }) => {
      let formData = new FormData();
      formData.append("json_data", JSON.stringify(value));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
      axiosInstance
        .post("/ticket-comments/new-comment", formData)
        .then((res) => {
          if (res.status === 201 || res.data.status == true) {
            // console.log(res);
            resetForm();
            setSelectedFile([]);
            setImage([]);
            getComments();
            //   onCancel();
            api.success({
              message: `Comment Display successfully`,
              // description:'',
              placement: "bottomRight",
            });
          } else {
            api.error({
              message: `Comment Display failed`,
              description: res.data.msg | "Network error",
              placement: "bottomRight",
            });
          }
        })
        .catch((err) => {
          api.error({
            message: `Comment Display failed`,
            description: err?.response?.data.msg | "Network error",
            placement: "bottomRight",
          });
        });
    },
  });


  useEffect(() => {
    // getTask();
    getComments();
    //   getMembersAll();
    //   getTaskPriroty();
    //   getTaskStatus();
  }, []);

  const [filePathList, setFilePathList] = useState([]);
  useEffect(() => {
    if (
      data?.attachments !== null &&
      data?.attachments !== "None" &&
      data?.attachments !== "[]"
    ) {
      setFilePathList(data?.attachments?.length > 0 ? data?.attachments : []);
    }
  }, [data]);

  function SubmitAssignee(e) {
    e.preventDefault();
    // if (assignee.length > 0) {
    // }
    if (createNew.reminderTime == "None") {
      createNew.reminderTime = "";
    }
    createNew.assignedTo = assignee;
    let formData = new FormData();
    formData.append("taskData", JSON.stringify(createNew));
    formData.append("attachment", []);
    axios
      .put(`/Task/${supportTickViewId}`, formData)
      .then((res) => {
        if (res.status === 201 || res.data.status == true) {
          // getTask();
          api.success({
            message: `Task Updated successfully`,
            description: res?.data?.msg || "",
            placement: "bottomRight",
          });
          setOpenAssignee(false);
        } else {
          api.error({
            message: `Task Update failed`,
            description: res.data.msg || "Network error",
            placement: "bottomRight",
          });
        }
      })
      .catch((err) => {
        // setIsLoading(false)
        api.error({
          message: `Task Update failed`,
          description: err.response.data.msg || "Network error",
          placement: "bottomRight",
        });
      });
  }

  function SubmitCopyto(e) {
    e.preventDefault();
    // if (copyTo.length > 0) {

    if (createNew.reminderTime == "None") {
      createNew.reminderTime = "";
    }
    // }
    createNew.copyTo = copyTo;
    let formData = new FormData();
    formData.append("taskData", JSON.stringify(createNew));
    formData.append("attachment", []);
    axios
      .put(`/Task/${supportTickViewId}`, formData)
      .then((res) => {
        if (res.status === 201 || res.data.status == true) {
          // setIsLoading(false)
          // navigate(-1)
          // getData();
          // getTask();
          api.success({
            message: `Task Updated successfully`,
            description: res?.data?.msg || "",
            placement: "bottomRight",
          });
          setOpen(false);
        } else {
          // setIsLoading(false)
          api.error({
            message: `Task Update failed`,
            description: res.data.msg || "Network error",
            placement: "bottomRight",
          });
        }
      })
      .catch((err) => {
        // setIsLoading(false)
        api.error({
          message: `Task Update failed`,
          description: err.response.data.msg || "Network error",
          placement: "bottomRight",
        });
      });
  }

  function ChangeAssigee() {
    return (
      <>
        <form onSubmit={SubmitAssignee}>
          <div className=" flex gap-2 items-start">
            <div className=" w-[70%]">
              <Select
                mode="multiple"
                style={{ width: "100%" }}
                options={members}
                defaultValue={assignee}
                // value={members.find((i) => i.value == createSubTask.assignedTo) || ""}
                // disabled={members.length >= 2 ? false : true}
                // allowClear={formik.values[name]?true:false}
                // name={name}
                // placeholder={placeholder}
                onChange={handleChangeAssignee}
              />
            </div>
            <div className=" w-[30%]">
              <Button
                htmlType="submit"
                className=" text-black bg-mainColor-300 w-full"
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
      </>
    );
  }

  // Copy To
  function ChangeCopyTo() {
    return (
      <>
        <form onSubmit={SubmitCopyto}>
          <div className=" flex gap-2 items-start">
            <div className=" w-[70%]">
              <Select
                mode="multiple"
                style={{ width: "100%" }}
                options={allMembers}
                defaultValue={copyTo}
                // value={allMembers.find((i) => i.value == [8,6]) || ""}
                // disabled={allMembers.length <= 1 ? true : false}
                // allowClear={formik.values[name]?true:false}
                // name={name}
                placeholder="Select"
                onChange={handleChangeCopyTo}
              />
            </div>
            <div className=" w-[30%]">
              <Button
                htmlType="submit"
                className=" text-black bg-mainColor-300 w-full"
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
      </>
    );
  }

  function NowTime(time) {
    let finalTime = `${time}`;
    return <NuDate value={finalTime} format="DD-MMM-YYYY , hh:mm a" />;
  }

  // const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userDetails = DecryptData("sLiAtEdReSuEdArT") || "";

  const loginId = userDetails?.id;
  return (
    <div className="w-full h-full px-4 py-2 bg-[#F1F2FB]">
      <div className=" w-full mx-auto sm:flex justify-between">
        <Breadcrumb
          items={[
            // { name: "Testing&Commissioning" },
            { name: "Support-Tickets", link: "/tickets/support-tickets" },
            { name: "View" },
          ]}
        />
        <div className=" flex gap-2 justify-end">
          <Link
            to={`/tickets/support-tickets`}
            state={{
              currentPage: pageIndex,
              searchQuery: searchQuery != "" ? searchQuery : "",
            }}
          >
            <BackButton link={true} />
          </Link>
          {GetAccess("support_tickets_edit") &&
          <Link
            to={`/tickets/support-tickets/edit/${supportTickViewId}`}
            state={{
              data: data,
              from: `/tickets/support-tickets/view/${supportTickViewId}`,
            }}
          >
            <EditButton height="8" />
          </Link>}
        </div>
      </div>
      <div className="w-full mx-auto h-[calc(100vh-135px)] md:flex gap-x-2 text-[#111537] mt-2">
            <div className="md:w-[70%]  bg-white rounded-md drop-shadow-lg   overflow-hidden ">
       <div className="w-full border border-gray rounded-md px-2 py-2 flex flex-col  sm:flex-row justify-between items-start sm:items-center h-auto gap-3">
            <div>
              <div className="flex pb-2">
                {/* <p className="font-semibold text-[13px] text-[#6B6868]">
                  {data?.ticketDetails?.refNumber}{" "}
                </p> */}
                <p className="font-semibold text-[13px] text-[#111537]">{data?.ticketDetails?.refNumber}{" "} : {""}{data?.ticketDetails?.subject} </p>

                {/* <h3 className="font-semibold text-[13px] text-[#2A3647]  truncate">
                  : {data?.ticketDetails?.subject}
                </h3> */}
              </div>
              <div className="flex gap-4">
                 <div className="flex gap-1 items-center  text-xs text-[#6B6868]">
                  <span className="font-medium"><User2 size={14}/></span>
                  <span>{data?.createdBy?.name}</span>
                </div>
                <div className="flex gap-2 items-center  text-xs text-[#6B6868]">
                  <span className="font-medium"><CalendarDays size={14} className="text-gray-500 shrink-0" /></span>
                  <span>  <NuDate value={data?.ticketDetails?.createdAt} format="DD-MMM-YYYY , hh:mm a"  /></span>
                </div>
               
              </div>
            </div>

            <div className="flex gap-2">
             
              <div className="inline-flex border border-[#6B43C6] rounded-full text-xs overflow-hidden">
                <span className="bg-white text-black px-2 py-1 font-medium">
                  Priority
                </span>
                <span className="bg-[#6B43C6] text-white px-2 py-1 font-medium">
                  {data?.priority || "None"}
                </span>
              </div>
                <div className=" flex items-center  overflow-hidden rounded-full text-[10px] 2xl:text-xs  ">
                            <div className="  p-2 h-6  bg-white  rounded-s-full text-xs flex items-center border border-baseColor-primary">
                              Status{" "}
                            </div>
                            <div className="  p-2 h-6  bg-textColor-main text-white text-xs  rounded-e-full flex items-center">
                              {data?.ticketDetails?.status  || "-"}
                            </div>
                          </div>
            </div>
          </div>

          <div>
            <div className="mt-1">
              <div>
                <div className="h-[calc(100vh-333px)] overflow-y-auto pr-2">
                  {comment?.map((data, idx) => (
                    <div className="py-1" key={idx}>
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 rounded-full text-white font-medium flex justify-center items-center bg-mainColor-600 uppercase">
                          {data?.userName?.charAt(0)}
                        </div>
                        <p className="font-semibold text-xs text-[#707884]">
                          {data?.userName} {"on"}
                        </p>
                        <p className="text-[#111537] text-xs font-normal mt-0.5">
                          {NowTime(data?.createdAt)}
                        </p>
                        {data?.userId === loginId && (
                          <EditSupportComments
                            mainId={supportTickViewId}
                            data={data}
                            getData={getComments}
                          />
                        )}
                      </div>
                      <div className="pl-10 mt-0.5">
                        <p className="font-medium text-xs text-[#707884] text-justify">
                          {data?.comments}
                        </p>
                        {data?.attachments?.length > 0 &&(
              <div className="flex flex-wrap gap-2 mt-2">

                        
                          {data?.attachments.map((attachment, idx) => (
                            <ViewFiles data={attachment} key={idx} />
                          ))}
                          </div>)}
                      </div>
                    </div>
                  ))}
                </div>

                {/* <div className="w-full h-0.5 bg-[#F3F7FF] my-4"></div> */}

                <form onSubmit={formik.handleSubmit}>
                <div
  className="flex flex-col md:flex-row mt-14 items-center gap-2 md:gap-4 w-full border-t border-[#EAEBED] p-2 md:p-1"
  // style={{ boxShadow: '0 -1px 3px rgba(0, 0, 0, 0.1)' }}
>       <NuInput
                      type="text"
                      placeholder="Write a comment..."
                      formik={formik}
                      name="comments"
                      width="w-full md:w-10/12"
                    />

                    <div className="flex items-center justify-end gap-2 md:w-2/12">
                    <div className=" flex items-center gap-1">
                      {
                        image && image.map((item,idx)=>{
                          return(
                            <div className=" w-10 h-6 border rounded-md overflow-hidden" key={idx}>
                              <img src={item} alt="#" />
                            </div>
                          )
                        })
                      }
                    </div>
                      <CustomAttachmentUpload
                        handleChange={handleChangeImg}
                        width=""
                        multiple={true}
                      />

                      <button type="submit" className="border-none bg-white">
                        <div className="w-8 h-8 rounded-full p-2 bg-baseColor-primary flex justify-center items-center">
                          <svg
                            width="16"
                            height="14"
                            viewBox="0 0 16 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M2.00106 13.5325C1.71412 13.6472 1.44152 13.622 1.18327 13.4567C0.925023 13.2914 0.795898 13.0513 0.795898 12.7362V9.52959C0.795898 9.32873 0.853287 9.14939 0.968065 8.99157C1.08284 8.83375 1.24066 8.73332 1.44152 8.69028L7.68256 7.14078L1.44152 5.59128C1.24066 5.54824 1.08284 5.44781 0.968065 5.28999C0.853287 5.13217 0.795898 4.95283 0.795898 4.75197V1.54537C0.795898 1.22973 0.925023 0.989273 1.18327 0.823993C1.44152 0.658713 1.71412 0.633749 2.00106 0.7491L15.2579 6.34451C15.6166 6.50233 15.7959 6.76775 15.7959 7.14078C15.7959 7.51381 15.6166 7.77923 15.2579 7.93705L2.00106 13.5325Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="md:w-[30%] bg-white rounded-lg drop-shadow-lg ml-2 md:ml-0   mt-3 md:mt-0"> */}

        <div className="md:w-[30%] bg-white rounded-lg drop-shadow-lg py-1 px-3 mt-5 md:mt-0 overflow-auto">
          <div className="w-full grid  border border-gary mt-4  rounded-lg">
            <div className="bg-baseColor-primary  p-2 rounded-t-lg">
              <p className="text-xs text-white font-medium">Assignee</p>
            </div>
            <div className=" border border-gary  overflow-y-scroll h-28 rounded-b-lg p-2">
                  <div className="w-full flex items-center gap-1">
                <p className=" text-[#171A21] font-medium text-[11px] 2xl:text-xs text-left">
                  Assigned&nbsp;To&nbsp;&nbsp;&nbsp;:
                </p>

                <Popover
                  content={ChangeAssigee}
                  overlayStyle={{
                    width: "25vw",
                  }}
                  open={openAssignee}
                  placement="bottom"
                  title="Change or Reassign"
                  trigger="click"
                  // onOpenChange={handleOpenAssigneeChange}
                >
                  <div
                    className="w-full flex justify-start items-center gap-1  rounded-md h-9 text-xs"
                    // style={{ border: "1px solid #9DA3AA" }}
                  >
                    <NuAvatarGroupWithOutLink
                      link={true}
                      userdetails={data?.assignees?.assignedTo}
                    />

                    {/* <DownArrow /> */}
                  </div>
                </Popover>
              </div>
              {/* </div> */}
              {/* <div className=""> */}
              <div className="w-full flex items-center ">
                <p className="  text-[#171A21] font-medium text-[11px] 2xl:text-xs text-left">
                  Copy&nbsp;To&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;
                </p>
                <Popover
                  content={ChangeCopyTo}
                  open={open}
                  // onOpenChange={handleOpenCopyChange}
                  overlayStyle={{
                    width: "25vw",
                  }}
                  placement="bottom"
                  title="Change or Reassign"
                  trigger="click"
                >
                  <div
                    className="w-full flex justify-start items-center gap-1 p-[1px] rounded-md h-9  text-xs"
                    // style={{ border: "1px solid #9DA3AA" }}
                  >
                    <NuAvatarGroupWithOutLink
                      link={true}
                      userdetails={data?.assignees?.copyTo}
                    />
                    {/* <DownArrow /> */}
                  </div>
                </Popover>
              </div>
            </div>
          </div>
          <div className="w-full grid mt-4 border border-gary h-auto  rounded-lg">
            <div className="bg-baseColor-primary  p-2 rounded-t-lg">
              <p className="text-xs text-white font-medium">Details</p>
            </div>
            {/* <p className="text-xs text-[#111537] font-medium">Customer Detail</p> */}
                                    {GetAccess("client_details") &&(

            <div className="w-full flex px-2 justify-between">
              <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                Client
              </p>
              <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                : {data?.ticketDetails?.clientName}
              </p>
            </div>
                                    )}
            <div className="w-full flex px-2 justify-between">
              <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                {" "}
                Contract
              </p>
              <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                {" "}
                : {data?.ticketDetails?.contractRefNumber}
              </p>
            </div>
            <div className="w-full flex px-2 justify-between">
              <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                {" "}
                Response Date
              </p>
              <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                {" "}
                :{" "}
                {data?.ticketDetails?.responseDate ? (
                  <NuDate
                    value={data?.ticketDetails?.responseDate}
                    format="DD-MMM-YYYY"
                  />
                ) : (
                  "N/A"
                )}
              </p>
            </div>
            <div className="w-full flex px-2 justify-between">
              <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                {" "}
                Start Date
              </p>
              <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                {" "}
                :{" "}
                {data?.startDate ? (
                  <NuDate
                    value={data?.startDate}
                    format="DD-MMM-YYYY"
                  />
                ) : (
                  "N/A"
                )}
              </p>
            </div>
            <div className="w-full flex px-2 justify-between">
              <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                {" "}
                End Date
              </p>
              <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                {" "}
                :{" "}
                {data?.endDate ? (
                  <NuDate
                    value={data?.endDate}
                    format="DD-MMM-YYYY"
                  />
                ) : (
                  "N/A"
                )}
              </p>
            </div>
            <div className="w-full flex px-2 justify-between">
              <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                {" "}
                Ticket Type
              </p>
              <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                {" "}
                : {data?.ticketDetails?.ticketType}
              </p>
            </div>
          </div>
          <div className="w-full grid mt-4 border border-gary  rounded-lg">
            <div className=" ">
              <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                <p className="text-xs text-white font-medium">Attachments</p>
              </div>
              <div className=" border border-gary  overflow-y-scroll h-28 rounded-b-lg p-2">
                <div className="w-full flex gap-2 flex-wrap ">
                  {data?.attachments &&
                    filePathList.map((imgs, idx) => {
                      console.log("img", imgs);
                      return <FilesView fileView={imgs} key={idx} />;
                    })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewSupportTicket;
